import FormGenerator from '@app/Landing/FormGenerator'
import InlineScriptRenderer from '@app/Landing/InlineScriptRenderer'

export default function install(Vue) {
  Vue.component('LandingFormGenerator', FormGenerator)
  Vue.component('InlineScriptRenderer', InlineScriptRenderer)
}
